
import { Injectable, signal } from '@angular/core';

export type AppTheme = 'dark' | 'light';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  theme = signal<AppTheme>('dark');

  constructor() {
    if (typeof window !== 'undefined') {
      const saved = window.localStorage.getItem('dbi-theme') as AppTheme | null;
      const initial: AppTheme =
        saved === 'light' || saved === 'dark'
          ? saved
          : (window.matchMedia?.('(prefers-color-scheme: light)')?.matches ? 'light' : 'dark');
      this.setTheme(initial);
    }
  }

  toggle(): void {
    this.setTheme(this.theme() === 'dark' ? 'light' : 'dark');
  }

  setTheme(theme: AppTheme): void {
    this.theme.set(theme);
    if (typeof document !== 'undefined') {
      document.body.setAttribute('data-theme', theme);
    }
    if (typeof window !== 'undefined') {
      window.localStorage.setItem('dbi-theme', theme);
    }
  }
}
